// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentsCheckoutCardForm__button","authForm":"PaymentsCheckoutCardForm__authForm"};